import { i18n } from 'src/i18n';
import AssetService from 'src/modules/asset/assetService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';
import assetListActions from '../list/assetListActions';

const prefix = 'ASSET_FORM';

const assetFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: assetFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AssetService.find(id);
      }

      dispatch({
        type: assetFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: assetFormActions.INIT_ERROR,
      });

      getHistory().push('/asset');
    }
  },

  doCopy: (values) => async (dispatch) => {
    try {
      dispatch({
        type: assetFormActions.CREATE_STARTED,
      });

      await AssetService.create(values);

      dispatch({
        type: assetFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.asset.create.success'),
      );

      dispatch(assetListActions.doCopyFetch());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: assetFormActions.CREATE_ERROR,
      });
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: assetFormActions.CREATE_STARTED,
      });

      await AssetService.create(values);

      dispatch({
        type: assetFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.asset.create.success'),
      );

      getHistory().push('/asset');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: assetFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: assetFormActions.UPDATE_STARTED,
      });

      await AssetService.update(id, values);

      dispatch({
        type: assetFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.asset.update.success'),
      );

      // getHistory().push('/asset');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: assetFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default assetFormActions;
